import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Modal, Span } from "@icg360/design-system";

import { setCookie, trackEvent } from "utils";

import styles from "./easypay-enrollment-modal.module.scss";

type EasyPayEnrollmentModalProps = {
  show: boolean;
  onClose: () => void;
};

export const EasyPayEnrollmentModal = ({
  show,
  onClose,
}: EasyPayEnrollmentModalProps) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (show) trackEvent("EasyPay Modal Displayed");
  }, [show]);
  const handleEnrollClick = () => {
    trackEvent("EasyPay Modal Enroll Button Clicked");
    setCookie("mss-easypay-modal-dismissed", true);
    navigate("/my/billing/update");
    onClose();
  };

  const handleOnClose = () => {
    setCookie("mss-easypay-modal-dismissed", true);
    onClose();
  };

  return (
    <Modal
      open={show}
      heading="Save more with EasyPay"
      primaryAction="Enroll in EasyPay"
      onPrimaryAction={handleEnrollClick}
      tertiaryAction="Remind me later"
      onTertiaryAction={handleOnClose}
      onClose={handleOnClose}
    >
      <Span bold>
        Save on fees and keep your policy active without late payments.
      </Span>
      <div className={styles.mainText}>
        Switch to automated EasyPay payments from your bank account and you can
        save both money and paper: you’ll receive digital statements and send
        payments automatically each billing cycle.
      </div>
    </Modal>
  );
};
